import {GeocodingApiDto} from "../../api/model/rest";
import {none, Option, option} from "ts-option";

export default class LatLng {
	constructor(public readonly lat: number, public readonly lng: number) {}

	/**
	 * Return first found location for given response if any.
	 * @param {GeocodingApiDto} json
	 * @return {Option<LatLng>}
	 */
	public static fromJson(json: GeocodingApiDto): Option<LatLng> {
		if (json.status === "OK") {
			const location = json.results[0].geometry.location;
			return option(new LatLng(location.lat, location.lng));
		}
		else {
			return none;
		}
	}
}